import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import {
  CompanyDetails,
  CreateProfile,
  EditProfile,
  JobDetails,
  Likes,
  Messaging,
  ProfileTips,
  Contents,
  Top,
  TopAd,
  FeaturedJobs,
  FeatureTopics,
} from '~/components/templates';
import IntroduceCampaign from '~/components/templates/IntroduceCampaign';
import { LoadingOverlay } from './components/molecules';
import { useUser } from './containers';

const Private: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { user, loading } = useUser();
  if (loading) return <LoadingOverlay />;

  return user ? children : <Navigate to="/" />;
};

const AppRoutes = (): JSX.Element => (
  <Routes>
    <Route path="/">
      <Route index element={<Top variant="normal" />} />
      <Route path="ad" element={<Top variant="normal" />} />
      <Route path="ad_form" element={<TopAd />} />
      <Route path="information" element={<Top variant="normal" />} />
      <Route path="student/basic/">
        <Route path="*" element={<Top variant="intern" />} />
      </Route>
      <Route path="mendan" element={<Top variant="interview" />} />
      {/* <Route path="jobs" element={Home} /> */}
      <Route
        path="likes"
        element={
          <Private>
            <Likes />
          </Private>
        }
      />
      <Route path="jobs/:id" element={<JobDetails />} />
      <Route path="company/:id" element={<CompanyDetails />} />
      <Route path="/topics" element={<FeatureTopics />} />
      <Route path="topics/:slug" element={<FeaturedJobs />} />

      <Route
        path="messages"
        element={
          <Private>
            <Messaging />
          </Private>
        }
      />
      <Route
        path="messages/:threadId"
        element={
          <Private>
            <Messaging />
          </Private>
        }
      />
      <Route path="profile">
        <Route
          index
          element={
            <Private>
              <EditProfile />
            </Private>
          }
        />
        <Route
          path="new"
          element={
            <Private>
              <CreateProfile />
            </Private>
          }
        />
        <Route
          path="tips"
          element={
            <Private>
              <ProfileTips />
            </Private>
          }
        />
      </Route>

      <Route
        path="contents"
        element={
          <Private>
            <Contents />
          </Private>
        }
      />
      <Route
        path="campaign"
        element={
          <Private>
            <IntroduceCampaign />
          </Private>
        }
      />

      {/* fallback */}
      <Route path="*" element={<Navigate to="/" />} />
    </Route>
  </Routes>
);

export default AppRoutes;
